import {omitEmptyDeepFilters} from "@/helpers/functions";
import UserPerformanceRepository from "@/repository/portal/userPerformanceRepository";

const state = {
  selectedRows: [],
  selectedAll: false,
  isLoading: false,
  filters: {},
}

const getters = {
  selectedRows: state => state.selectedRows,
  selectedAll: state => state.selectedAll,
  isLoading: state => state.isLoading,
  filters: state => state.filters,
}

const actions = {
  async onBulkUpdate({getters, commit}, event) {
    state.isLoading = true
    let filters = {}
    if (getters.selectedAll) {
      filters = omitEmptyDeepFilters(getters.filters)
      delete filters.pagination
    } else filters = {
      ids: getters.selectedRows,
    }
    try {
      await UserPerformanceRepository.bulkUpdate({edit: event, ...filters})
      commit('onResetAll')
    } catch (e) {
      console.log(e)
    }
    state.isLoading = false
  },
}

const mutations = {
  onSelectRow(state, {event, uuid}) {
    if (!state.selectedAll) {
      if (event && !state.selectedRows.includes(uuid)) state.selectedRows.push(uuid)
      if (!event && state.selectedRows.includes(uuid)) state.selectedRows = state.selectedRows.filter(i => i !== uuid)
    } else {
      if (!event && !state.selectedRows.includes(uuid)) state.selectedRows.push(uuid)
      if (event && state.selectedRows.includes(uuid)) state.selectedRows = state.selectedRows.filter(i => i !== uuid)
    }
  },
  onSelectAll(state, payload) {
    const {event, params} = payload
    state.selectedAll = event
    state.filters = params
    state.selectedRows = []
  },
  onResetAll(state){
    state.selectedRows = []
    state.selectedAll = false
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
